export default "__VITE_ASSET__DXvVa1hE__"